import React from "react";
import PropTypes from "prop-types";
import { CSSTransitionGroup } from "react-transition-group";

function Result(props) {
  return (
    <CSSTransitionGroup
      className="container result"
      component="div"
      transitionName="fade"
      transitionEnterTimeout={800}
      transitionLeaveTimeout={500}
      transitionAppear
      transitionAppearTimeout={500}
    >
      <h3>What’s your score?</h3>

      <div>
        You answered Yes <strong>{props.answersCount.Yes}</strong> times.
      </div>
      <div>
        You answered No <strong>{props.answersCount.No}</strong> times.
      </div>

      <p>
        If you have answered <strong>YES</strong> to any one of the questions,
        there is a definite warning that you may be an alcoholic.
      </p>
      <p>
        If you have answered <strong>YES</strong> to any two, the chances are
        that you are an alcoholic.
      </p>
      <p>
        If you have answered <strong>YES</strong> to three or more, you are
        almost certainly an alcoholic.
      </p>
      <h3>Why do we say this?</h3>
      <p>
        Only because the experience of hundreds of thousands of recovering
        alcoholics has taught us some basic truths about our symptoms - and
        about ourselves.
      </p>
    </CSSTransitionGroup>
  );
}

Result.propTypes = {
  answersCount: PropTypes.object.isRequired
};

export default Result;



// WEBPACK FOOTER //
// ./src/components/Result.js